<template>
  <v-container>
    <getting-data-overlay :is_loading="is_loading"
                          :loading_display_title="$vuetify.lang.t('$vuetify.checklist.getting_data_title')"></getting-data-overlay>
    <v-row v-if="!is_loading && !has_loading_error">
      <v-col cols="12">
        <list-view :checklistItems="checklist_items" v-if="checklist_items.length > 0"></list-view>
      </v-col>
    </v-row>
    <v-row v-if="has_loading_error">
      <v-col cols="12">
        <v-col cols="12" class="subtitle-1 text-center">
          {{ $vuetify.lang.t('$vuetify.errors.checklistNotLoaded') }}
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
//import LMRADataGetService from "../../../helpers/axios/LMRADataGetService";
//import appSettings from "../../../mixins/config/appSettings";
import GettingDataOverlayComponent from "../global/gettingDataOverlayComponent/GettingDataOverlayComponent";
import resourcesApi from "@/api/resources/resourcesApi";
import ChecklistListViewComponent from "@/components/modules/checklist/ChecklistListViewComponent";

export default {
  name: "checklisComponent",
  data: () => {
    return {
      is_loading: false,
      has_loading_error: false,
      checklist_items: []
    }
  },
  components: {
    gettingDataOverlay: GettingDataOverlayComponent,
    listView : ChecklistListViewComponent
  },
  methods: {

    async get_checklist() {
      this.is_loading = true;
      let checklistId = await this.getCurrentProjectChecklistId()

      resourcesApi.getChecklist(checklistId).then((response) => {
        this.checklist_items = response.data.checklist_items;
        this.is_loading = false;
      }).catch(
          (error) => {
            this.is_loading = false;
            this.has_loading_error = true;
            window.console.error(error);
          }
      )
    },
    async getCurrentProjectChecklistId() {
      let activeSession = await this.$store.getters.getActiveWorkSession;
      /*window.console.log('ACTIVE SESSION');
      window.console.log(activeSession);*/
      return (
          activeSession !== undefined &&
          activeSession !== null &&
          typeof activeSession === 'object' &&
          activeSession.project_settings !== undefined &&
          activeSession.project_settings !== null &&
          activeSession.project_settings.linked_checklist_id !== undefined
      ) ? activeSession.project_settings.linked_checklist_id : null;
    },
  },
  async mounted(){
    if(!this.$workSessions.loading && !this.hasForceCloseWorkSessionFlag){
      await this.$workSessions.performSessionCheck();
      if(this.$auth.isAuthenticated){
        this.get_checklist();
      }
    }
  }
}
</script>

<style scoped>
.checklist-item {
  padding: 20px;
  min-height: 60px;
}
</style>